<form class="g-3 needs-validation" novalidate [formGroup]="formFields" (ngSubmit)="onSubmit()">
  <!-- Horse Details Section -->
  <div class="form_sections">
    <h4><u>Horse Details</u></h4>
    
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Stable Name <span class="text-danger">*</span></label>
          <input
            type="text"
            name="stable_name"
            formControlName="stable_name"
            placeholder="Stable Name"
            class="form-control form-control-sm"
            required
            [ngClass]="{
              'is-invalid':
                (f.stable_name.touched || submitted) &&
                (f.stable_name.errors?.required ||
                  f.stable_name.errors?.notCapitalized)
            }"
          />
          <div
            class="invalid-feedback"
            *ngIf="
              (f.stable_name.touched || submitted) &&
              f.stable_name.errors?.required
            "
          >
            Stable Name is required.
          </div>
          <div
            class="invalid-feedback"
            *ngIf="
              (f.stable_name.touched || submitted) &&
              f.stable_name.errors?.notCapitalized
            "
          >
            Every new word should start with a capital, even if hyphenated.
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Passport Name <span class="text-danger">*</span></label>
          <input
            type="text"
            name="passport_name"
            formControlName="passport_name"
            placeholder="Passport Name"
            class="form-control form-control-sm"
            required
            [ngClass]="{
              'is-invalid':
                (f.passport_name.touched || submitted) &&
                (f.passport_name.errors?.required ||
                  f.passport_name.errors?.notCapitalized)
            }"
          />
          <div
            class="invalid-feedback"
            *ngIf="
              (f.passport_name.touched || submitted) &&
              f.passport_name.errors?.required
            "
          >
            Passport Name is required.
          </div>
          <div
            class="invalid-feedback"
            *ngIf="
              (f.passport_name.touched || submitted) &&
              f.passport_name.errors?.notCapitalized
            "
          >
            Every new word should start with a capital, even if hyphenated.
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Acquired Date <span class="text-danger">*</span></label><br />
          <input
            type="text"
            required
            name="acquired_date"
            formControlName="acquired_date"
            placeholder="DD/MM/YYYY"
            class="form-control form-control-sm datepicker"
            matInput
            (focus)="acquiredDateDatepicker.open()"
            [matDatepicker]="acquiredDateDatepicker"
            [max]="maxAcquiredDate"
            [ngClass]="{
              'is-invalid':
                (f.acquired_date.touched || submitted) &&
                (f.acquired_date.errors?.required ||
                  f.acquired_date.errors?.acquiredAfterCover)
            }"
          />
          <mat-datepicker-toggle [for]="acquiredDateDatepicker"></mat-datepicker-toggle>
          <mat-datepicker #acquiredDateDatepicker></mat-datepicker>
          <div
            class="invalid-feedback"
            *ngIf="
              (f.acquired_date.touched || submitted) &&
              f.acquired_date.errors?.required
            "
          >
            Acquired Date is required.
          </div>
          <div
            class="invalid-feedback"
            *ngIf="
              (f.acquired_date.touched || submitted) &&
              f.acquired_date.errors?.acquiredAfterCover
            "
          >
            Cover cannot start prior to the date the horse was acquired - please review the cover date / acquired date
          </div>
          <small class="form-text text-white">Enter the date the horse was purchased, loaned, leased, gifted or adopted. If the horse is homebred, enter the date of birth.</small>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Ownership Status <span class="text-danger">*</span></label>
          <mat-form-field class="w-100" style="margin-top: 0;">
            <mat-select
              formControlName="ownership_status"
              class="form-control form-control-sm"
              name="ownership_status"
              required
              [ngClass]="{
                'is-invalid':
                  (f.ownership_status.touched || submitted) &&
                  f.ownership_status.errors?.required
              }"
            >
              <mat-option [value]="">Select Ownership Status</mat-option>
              <mat-option *ngFor="let status of ownershipStatuses" [value]="status.id">
                {{ status.status_name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div
            class="invalid-feedback"
            *ngIf="
              (f.ownership_status.touched || submitted) &&
              f.ownership_status.errors?.required
            "
          >
            Ownership Status is required.
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Purchase Price <span class="text-danger">*</span></label>
          <input
            type="number"
            name="purchase_price"
            formControlName="purchase_price"
            placeholder="Purchase Price"
            class="form-control form-control-sm"
            required
            min="0"
            step="1"
            [ngClass]="{
              'is-invalid':
                (f.purchase_price.touched || submitted) &&
                (f.purchase_price.errors?.required ||
                  f.purchase_price.errors?.notWholeNumber)
            }"
          />
          <div
            class="invalid-feedback"
            *ngIf="
              (f.purchase_price.touched || submitted) &&
              f.purchase_price.errors?.required
            "
          >
            Purchase Price is required.
          </div>
          <div
            class="invalid-feedback"
            *ngIf="
              (f.purchase_price.touched || submitted) &&
              f.purchase_price.errors?.notWholeNumber
            "
          >
            Purchase Price must be a whole number in pounds.
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Sum Insured <span class="text-danger">*</span></label>
          <input
            type="number"
            name="sum_insured"
            formControlName="sum_insured"
            placeholder="Sum Insured"
            class="form-control form-control-sm"
            required
            min="0"
            step="1"
            [ngClass]="{
              'is-invalid':
                (f.sum_insured.touched || submitted) &&
                (f.sum_insured.errors?.required ||
                  f.sum_insured.errors?.notWholeNumber ||
                  f.sum_insured.errors?.sumInsuredExceedsPurchase ||
                  f.sum_insured.errors?.sumInsuredTooLow)
            }"
          />
          <div
            class="invalid-feedback"
            *ngIf="
              (f.sum_insured.touched || submitted) &&
              f.sum_insured.errors?.required
            "
          >
            Sum Insured is required.
          </div>
          <div
            class="invalid-feedback"
            *ngIf="
              (f.sum_insured.touched || submitted) &&
              f.sum_insured.errors?.notWholeNumber
            "
          >
            Sum Insured must be a whole number in pounds.
          </div>
          <small
            class="form-text text-warning d-block"
            *ngIf="(f.sum_insured.touched || submitted) && showSumInsuredOver50kReferralMessage"
          >
            The maximum authorised Sum Insured is £50,000 - higher Sums Insured will require referral before we are able to quote.
          </small>
          <small
            class="form-text text-warning d-block"
            *ngIf="(f.sum_insured.touched || submitted) && showRestrictedSumInsuredOver20kReferralMessage"
          >
            Sum Insured over £20,000 with Restricted cover will refer this quote to Underwriters when you submit from Premium Summary.
          </small>
          <div
            class="invalid-feedback"
            *ngIf="
              (f.sum_insured.touched || submitted) &&
              f.sum_insured.errors?.sumInsuredExceedsPurchase
            "
          >
            The Sum Insured cannot exceed the purchase price until at least 60 days after the acquired date
          </div>
          <div
            class="invalid-feedback"
            *ngIf="
              (f.sum_insured.touched || submitted) &&
              f.sum_insured.errors?.sumInsuredTooLow
            "
          >
            The Sum Insured cannot be more than 50% lower than the purchase price for a newly purchased horse
          </div>
          <small class="form-text text-white">The Sum Insured is the maximum that will be paid in the event of a claim for Loss of Horse and should reflect the horse's current fair market value and not be based on future or potential value. For newly purchased horses, the Sum Insured should not be higher than the purchase price or more than 50% lower than the purchase price.</small>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Year of Birth <span class="text-danger">*</span></label>
          <mat-form-field class="w-100" style="margin-top: 0;">
            <mat-select
              formControlName="horse_birth_year"
              class="form-control form-control-sm"
              name="horse_birth_year"
              required
              [ngClass]="{
                'is-invalid':
                  (f.horse_birth_year.touched || submitted) &&
                  f.horse_birth_year.errors?.required
              }"
            >
              <mat-option [value]="">Select Year of Birth</mat-option>
              <mat-option *ngFor="let year of yearsOfBirth" [value]="year">
                {{ year }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div
            class="invalid-feedback"
            *ngIf="
              (f.horse_birth_year.touched || submitted) &&
              f.horse_birth_year.errors?.required
            "
          >
            Year of Birth is required.
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Age</label>
          <input
            type="text"
            name="age"
            formControlName="age"
            placeholder="Age"
            class="form-control form-control-sm"
            readonly
            [ngClass]="{
              'is-invalid':
                (f.age.touched || submitted) &&
                calculatedAge === 0
            }"
          />
          <div
            class="invalid-feedback"
            *ngIf="calculatedAge === 0"
          >
            Please ensure the foal will be 30 days of age or older when cover starts - there is no cover for foals under 30 days
          </div>
          <small class="form-text text-white">The age is calculated based on 1st January of the year selected</small>
        </div>
      </div>
    </div>
  </div>

  <!-- Submit Button -->
  <div class="row mt-4">
    <div class="col-md-12 text-right">
      <button type="submit" class="btn btn-success btn-sm">Save & Continue</button>
    </div>
  </div>
</form>
